import { InjectionToken } from '@angular/core';
import { Environment } from '../types/env-config.type';

// Environment object to be provided based on project
export const ENVIRONMENT_CONFIG = new InjectionToken<Environment>('EnvironmentConfig');

/**
 * For providing the environment config in a given TestBed testing module
 * @param envConfig The environment object to be provided
 */
export const provideEnvironmentConfig = (envConfig: any = {}) => {
  return {
    provide: ENVIRONMENT_CONFIG,
    useValue: envConfig
  };
};
